<template>
  <b-modal
    id="showEmailPreview"
    size="lg"
    scrollable
    ok-only
    ok-title="Chiudi"
    ok-variant="-transparent"
    header-bg-variant="lisaweb"
    no-close-on-esc
    no-close-on-backdrop
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <b-icon icon="mailbox"></b-icon>
        <span>Preview Email</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel()"
      >
        <base-icon name="close" width="14" height="14"/>
      </button>
    </template>
    <template #modal-footer="{ cancel }">
      <b-form-group>
        <b-btn @click="cancel()" size="sm" variant="-transparent"
        >Chiudi
        </b-btn
        >
      </b-form-group>
    </template>
    <div class="form-card-wrapper my-3">
      <b-card style="overflow-y: auto; max-height: 700px;" header-tag="header">
        <template #header>
          <b>Email</b>
        </template>
        <b-card-text>
          <p class="subject">{{ subject }}</p>
          <hr/>
          <div>
            <div v-html="email"></div>
          </div>
        </b-card-text>
      </b-card>
    </div>
  </b-modal>
</template>
<script>
import BaseIcon from "@/components/BaseIcon";

export default {
  components: {BaseIcon},
  data() {
    return {};
  },
  props: {
    subject: {
      type: String,
    },
    email: {
      type: String,
    },
  },
};
</script>

<style scoped>
.subject {
  font-weight: bold;
  font-size: 1.5em;
}
</style>
